// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Isolation Units API
 * Manage isolation units, clusters and partitions.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Resources
 */
export interface Resources {
  /**
   *
   * @type {string}
   * @memberof Resources
   */
  awsAccountId?: string;
  /**
   *
   * @type {string}
   * @memberof Resources
   */
  azureSubscriptionId?: string;
  /**
   *
   * @type {string}
   * @memberof Resources
   */
  gcpProjectId?: string;
}

/**
 * Check if a given object implements the Resources interface.
 */
export function instanceOfResources(value: object): value is Resources {
  return true;
}

export function ResourcesFromJSON(json: any): Resources {
  return ResourcesFromJSONTyped(json, false);
}

export function ResourcesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Resources {
  if (json == null) {
    return json;
  }
  return {
    awsAccountId:
      json['aws_account_id'] == null ? undefined : json['aws_account_id'],
    azureSubscriptionId:
      json['azure_subscription_id'] == null
        ? undefined
        : json['azure_subscription_id'],
    gcpProjectId:
      json['gcp_project_id'] == null ? undefined : json['gcp_project_id'],
  };
}

export function ResourcesToJSON(json: any): Resources {
  return ResourcesToJSONTyped(json, false);
}

export function ResourcesToJSONTyped(
  value?: Resources | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aws_account_id: value['awsAccountId'],
    azure_subscription_id: value['azureSubscriptionId'],
    gcp_project_id: value['gcpProjectId'],
  };
}
